import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import hat from 'hat';
import Row from './Row';
import Cell from './Cell';
import Arrow from './Arrow';

import { getSupportIndicator } from './utils';

export default class CapabilityRow extends Component {
    static propTypes = {
        capability: PropTypes.string.isRequired,
        capabilities: PropTypes.object.isRequired,
        channels: PropTypes.array.isRequired,
        isLastRow: PropTypes.bool.isRequired,
        className: PropTypes.string.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    generateDirectionCell() {
        const { capability } = this.props;
        const capabilityDetails = this.props.capabilities[capability];

        let directionCell;
        if (capabilityDetails.send && capabilityDetails.receive) {
            directionCell = (
                <Cell className="direction-cell" divided>
                    <div className="top-part">
                        <Arrow direction="right" />
                    </div>
                    <div className="bottom-part">
                        <Arrow direction="left" />
                    </div>
                </Cell>
            );
        } else if (capabilityDetails.send) {
            directionCell = (
                <Cell className="direction-cell">
                    <Arrow direction="right" />
                </Cell>
            );
        } else if (capabilityDetails.receive) {
            directionCell = (
                <Cell className="direction-cell">
                    <Arrow direction="left" />
                </Cell>
            );
        } else {
            directionCell = <Cell className="direction-cell" divided />;
        }

        return directionCell;
    }

    generateInformationOverlay(information) {
        if (!information) {
            return null;
        }

        return <Popover id={hat()}>{information}</Popover>;
    }

    generateCells() {
        const { capability } = this.props;
        const capabilityDetails = this.props.capabilities[capability];

        return this.props.channels.map((channel, i) => {
            const support = channel.capabilities[capability];

            let cell;
            const sendPopover = this.generateInformationOverlay(support.sendInformation);
            const receivePopover = this.generateInformationOverlay(support.receiveInformation);
            const infoPopover = this.generateInformationOverlay(support.information);
            if (capabilityDetails.send && capabilityDetails.receive) {
                const topPart = sendPopover ? (
                    <div className="top-part">
                        <OverlayTrigger rootClose trigger="click" placement="top" overlay={sendPopover}>
                            {getSupportIndicator(support.send, true)}
                        </OverlayTrigger>
                    </div>
                ) : (
                    <div className="top-part">{getSupportIndicator(support.send)}</div>
                );

                const bottomPart = receivePopover ? (
                    <div className="bottom-part">
                        <OverlayTrigger rootClose trigger="click" placement="top" overlay={receivePopover}>
                            {getSupportIndicator(support.receive, true)}
                        </OverlayTrigger>
                    </div>
                ) : (
                    <div className="bottom-part">{getSupportIndicator(support.receive)}</div>
                );

                cell = (
                    <Cell key={i} divided isContent>
                        {topPart}
                        {bottomPart}
                    </Cell>
                );
            } else if (capabilityDetails.send) {
                const content = sendPopover ? (
                    <OverlayTrigger rootClose trigger="click" placement="top" overlay={sendPopover}>
                        {getSupportIndicator(support.send, true)}
                    </OverlayTrigger>
                ) : (
                    getSupportIndicator(support.send)
                );

                cell = (
                    <Cell key={i} isContent>
                        {content}
                    </Cell>
                );
            } else if (capabilityDetails.receive) {
                const content = receivePopover ? (
                    <div className="bottom-part">
                        <OverlayTrigger rootClose trigger="click" placement="top" overlay={receivePopover}>
                            {getSupportIndicator(support.receive, true)}
                        </OverlayTrigger>
                    </div>
                ) : (
                    getSupportIndicator(support.receive)
                );

                cell = (
                    <Cell key={i} isContent>
                        {content}
                    </Cell>
                );
            } else if (support.level) {
                const content = infoPopover ? (
                    <OverlayTrigger rootClose trigger="click" placement="top" overlay={infoPopover}>
                        {getSupportIndicator(support.level, true)}
                    </OverlayTrigger>
                ) : (
                    getSupportIndicator(support.level)
                );
                cell = (
                    <Cell key={i} isContent>
                        {content}
                    </Cell>
                );
            } else {
                cell = (
                    <Cell key={i} isContent>
                        {getSupportIndicator(support)}
                    </Cell>
                );
            }

            return cell;
        });
    }

    generateLink(capabilityDetails) {
        if (capabilityDetails.isExternalLink) {
            return (
                <a href={capabilityDetails.link} target="_blank" rel="noopener noreferrer">
                    {capabilityDetails.name}
                </a>
            );
        }

        return (
            <Link to={capabilityDetails.link} target={capabilityDetails.link.startsWith('/') ? undefined : '_blank'}>
                {capabilityDetails.name}
            </Link>
        );
    }

    render() {
        const { className, capability, isLastRow } = this.props;
        const capabilityDetails = this.props.capabilities[capability];

        const classNames = ['grid-row'];
        if (className) {
            classNames.push(className);
        }

        return (
            <Row className={classNames.join(' ')}>
                <Cell verticalHeader>
                    <Cell alignLeft bottomBorder={!isLastRow}>
                        {capabilityDetails.link ? this.generateLink(capabilityDetails) : capabilityDetails.name}
                    </Cell>
                    {this.generateDirectionCell()}
                </Cell>
                {this.generateCells()}
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/CapabilityRow.js